import { Injectable } from '@angular/core';
import { ModuleType } from '@contracts';
import { QueryParams } from '../http/api-client.types';
import { SessionStore } from '../session/session.store';

@Injectable({ providedIn: 'root' })
export class ModuleRequestHelper {
  constructor(private readonly sessionStore: SessionStore) {}

  getModuleOrThrow(): ModuleType {
    const module = this.sessionStore.getModule();

    if (!module) {
      throw new Error('Module is not set in session');
    }

    return module;
  }

  withModuleQuery<T extends QueryParams | undefined>(
    query?: T,
  ): (T extends undefined ? {} : T) & { sensor_module: ModuleType } {
    return {
      ...(query ?? ({} as T)),
      sensor_module: this.getModuleOrThrow(),
    } as (T extends undefined ? {} : T) & { sensor_module: ModuleType };
  }

  withModuleBody<T extends object>(body: T): T & { sensor_module: ModuleType } {
    return {
      ...body,
      sensor_module: this.getModuleOrThrow(),
    };
  }
}
